import { useResizeObserver } from '@mantine/hooks';
import { useEffect, useState } from 'react';

export function useInitialSize() {
  const [[width, height], setSize] = useState<[number, number]>([0, 0]);
  const [ref, containerSize] = useResizeObserver();

  useEffect(() => {
    if (containerSize.width && containerSize.height && (!width || !height)) {
      setSize([containerSize.width, containerSize.height]);
    }
  }, [containerSize, width, height]);

  return [ref, { width, height }] as const;
}
